/** A connected assistant's timestamps, as a medium date and a short time in the reader's language. */
export function formatAssistantDate(value: string, language: string): string {
  return new Intl.DateTimeFormat(language, { dateStyle: 'medium', timeStyle: 'short' }).format(
    new Date(value)
  );
}
